import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NotOnSmall, OnlyOnSmall } from '@xing-com/layout-primitives';
import { Hero } from '@xing-com/typography';

import * as Styled from './pre-screening-dialog.styles';

export const PrescreeningHeadline: React.FC = () => {
  return (
    <React.Fragment>
      <NotOnSmall>
        <Hero as={'h2'} size="small">
          <FormattedMessage id={'JOBS_JOB_DETAILS_PRE_SCREENING_HEADLINE'} />
        </Hero>
        <Styled.SubHeadline size="large">
          <FormattedMessage id="JOBS_JOB_DETAILS_PRE_SCREENING_DESCRIPTION" />
        </Styled.SubHeadline>
      </NotOnSmall>
      <OnlyOnSmall>
        <Styled.Headline size="xxlarge">
          <FormattedMessage id={'JOBS_JOB_DETAILS_PRE_SCREENING_HEADLINE'} />
        </Styled.Headline>
        <Styled.SubHeadline size="small">
          <FormattedMessage id="JOBS_JOB_DETAILS_PRE_SCREENING_DESCRIPTION" />
        </Styled.SubHeadline>
      </OnlyOnSmall>
    </React.Fragment>
  );
};
